@if (filterData$ | async; as filterData) {
    <div class="flex justify-space-between">
        <mat-chip-listbox>
            @if (filterData.search) {
                <mat-chip-option (removed)="removeSearch()">
                    <mat-icon matChipAvatar>search</mat-icon>
                    {{ filterData.search }}
                    <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip-option>
            }
            @for (tag of filterData.tags; track tag) {
                <mat-chip-option (removed)="removeTag(tag, filterData.tags)">
                    <mat-icon matChipAvatar>label</mat-icon>
                    {{ tag }}
                    <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip-option>
            }
            @for (user of filterData.users; track user) {
                <mat-chip-option (removed)="removeUser(user, filterData.users)">
                    <mat-icon matChipAvatar>person</mat-icon>
                    {{ user }}
                    <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip-option>
            }
            @for (date of filterData.dates; track date; let last = $last) {
                @if (date !== null) {
                    <mat-chip-option (removed)="removeDate(date, filterData.dates)">
                        @if (!last) {
                            <mat-icon matChipAvatar>today</mat-icon>
                        }
                        @if (last) {
                            <mat-icon matChipAvatar>event</mat-icon>
                        }
                        {{ date }}
                        <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip-option>
                }
            }
        </mat-chip-listbox>
        @if (filterData.search || filterData.tags || filterData.users) {
            <button mat-icon-button (click)="clear()" matTooltip="Clear Filters">
                <mat-icon>close</mat-icon>
            </button>
        }
    </div>
}
